export const AUTH_TOKEN = "auth_token";
export const AUTH_NAME = "auth_name";
export const AUTH_ROLE = "auth_role";
export const AUTH_ROLE_ID = "auth_roleId";
export const AUTH_USER_ID = "auth_userId";
export const AUTH_TEACHER_ID = "auth_teacherId";
export const AUTH_STUDENT_ID = "auth_studentId";
export const AUTH_CURRENT_SESSION = "auth_current_sessionId";
export const AUTH_CURRENT_DATA = "auth_current_data";


